module.exports = __webpack_public_path__ + "static/img/153.8b1acb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/153.png
// module id = j8hE
// module chunks = 0